export default "__VITE_ASSET__2be36a2b__"